"use client";

import { HelmetProvider } from "react-helmet-async";
import AppShell from "./AppShell";

const AppShellRoot = ({ children }) => (
  <HelmetProvider>
    <AppShell>{children}</AppShell>
  </HelmetProvider>
);

export default AppShellRoot;
